<template>
  <div>
    <header>
      <div class="row border-grey toggle-tabs g-0">
        <h2 class="text-capitalize border-grey m-0 pb-3">Dashboard</h2>
        <router-link
          class="col-6 text-center anchor-tab"
          :to="{ name: 'Dashboard' }"
          replace
        >
          Score
        </router-link>
        <router-link
          class="col-6 text-center anchor-tab"
          :to="{ name: 'Trends' }"
          replace
          >Trends
        </router-link>
      </div>
    </header>

    <div class="main-dashboard-info-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainDashboardInformation",
  created() {
    const favicon = document.getElementById("favicon");
    let splitURL = favicon.href.split("/");

    if (this.$store.getters["auth/tenantType"] == "TED") {
      splitURL[splitURL.length - 1] = "ted.ico";
      favicon.href = splitURL.join("/");
    } else if (this.$store.getters["auth/tenantType"] == "CED") {
      splitURL[splitURL.length - 1] = "ced.ico";
      favicon.href = splitURL.join("/");
    } else {
      splitURL[splitURL.length - 1] = "favicon.ico";
      favicon.href = splitURL.join("/");
    }
  },
  mounted() {
    this.$store.dispatch("mainStats/fetchSurveysGroupWithColors");
  },
  destroyed() {
    this.$store.dispatch("mainStats/resetGroupSurveys");
  },
};
</script>

<style lang="scss" scoped>
.main-dashboard-info-container {
  overflow: auto;
  height: calc(100vh - 9.8rem);
}

::-webkit-scrollbar {
  width: 0;
}
</style>
